import React from 'react';
import { graphql } from "gatsby";
import PropTypes from 'prop-types';
import ModuleWrapper from '../../globals/moduleWrapper/moduleWrapper';
import HtmlBlock from '../../components/htmlBlock/htmlBlock';
import Image from '../../components/image/image';
import Link from '../../components/link/link';

/**
 * CMS Component: DatoCmsModuleLogo
 * 
 */
const Logos = ({data, className, ...other}) => {
    // console.log('logos', data);
    const {anchor, border, heading, link, logos} = data || {};
    return (
        <ModuleWrapper anchor={anchor} border={border} className={`logos ${className || ''}`} {...other}>
          {
            heading && <HtmlBlock tag={'h2'} >{heading}</HtmlBlock>
          }
          {
            logos && 
            <div className={`logos__content`}>
              {
                logos.map((logo, i)=>{
                  return <Image className="contrain" data={logo} key={i} decorative={false} width={157} />
                })
              }
            </div>
          }
          {
            link && <Link data={link} className={`btn--primary`}/>
          }
        </ModuleWrapper>
    );
};

Logos.propTypes = {
  /**
  * Data from cms
  */
  data:  PropTypes.shape({
    anchor: PropTypes.string,
    border: PropTypes.oneOf(['', 'None', 'Gradient Border Bottom', 'Gradient Border Top', 'Lifted Top', 'Lifted Bottom', 'Lifted Fully']),
    heading: PropTypes.string,
    link: PropTypes.array,
    logos: PropTypes.array
  }),
};

export default Logos;

export const ModuleLogosFragment = graphql`
fragment ModuleLogosFragment on DatoCmsModuleLogo {
  anchor
  toggleId
  border
  heading
  link{
    ...LinkFragment
  }
  logos{
    ...LogoFragment
  }
  toggleId
}
`;